import { Component, type ErrorInfo, type ReactNode } from 'react'

import { ErrorState } from './StateMessage'

interface Props {
  children: ReactNode
  /** Changing it (e.g. the route) clears a caught error so navigation recovers. */
  resetKey?: string
}

interface State {
  failed: boolean
}

/**
 * Contains a render error to the region it wraps, so one broken panel shows a message instead of
 * unmounting the whole app (React drops the entire tree on an uncaught render error).
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('render error', error, info.componentStack)
  }

  componentDidUpdate(prev: Props): void {
    if (this.state.failed && prev.resetKey !== this.props.resetKey) this.setState({ failed: false })
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children
    return (
      <ErrorState>
        Something went wrong showing this view. Reload the page; if it keeps happening, tell an FPA admin.
      </ErrorState>
    )
  }
}
